module.exports = __webpack_public_path__ + "7d89b8a49c164c6bb5963e0bea8b58d8.png";